import { useEffect } from "react";
import { markChapterNotificationAsRead } from "./services";
import { useSearchParams } from "react-router-dom";
import { useNotificationStore } from "./store";

export function useMarkChapterNotificationAsRead() {
  const [searchParams] = useSearchParams();
  const chapterId = searchParams.get("chapterId");
  const markChapterAsRead = useNotificationStore((state) => state.markChapterAsRead);

  useEffect(() => {
    if (chapterId) {
      const hasSomethingChanged = markChapterAsRead(Number(chapterId));

      if (hasSomethingChanged) {
        markChapterNotificationAsRead(Number(chapterId)).catch((error) => {
          console.error("Failed to mark notification as read:", error);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chapterId]);
}
